module.exports = __webpack_public_path__ + "static/amresha-icon-c2e66681d9cec7530c75fba43fbaa17c.png";